namespace B2B.UI {
    export interface IMessagePopupOptions{
        title: string,
        text: string
    }
    export class MessagePopup extends B2B.UI.Popup{
        private _options: IMessagePopupOptions;
        private _resolve: (data: IPopupResult) => any;
        private readonly _template: HTMLElement;

        constructor(options: IMessagePopupOptions) {
            super();
            this._options = options;

            this.element.classList.add("b-popup-message");
            this._template = this.createHtml(`<form class="form">
                <div class="form__title js-title">${this._options.title || "СПАСИБО!"}</div>
                <div class="form__mini-text js-text">${this._options.text || "Ваше обращение уже в работе. Мы свяжемся с Вами!"}</div>
            </form>`);
        }

        public createHtml(htmlText: string): HTMLElement {
            let container = document.createElement("div");
            container.innerHTML = htmlText;
            let element = <HTMLElement>container.firstElementChild;
            container.removeChild(element);
            container = null;
            return element;
        }

        protected override onClose(){
            if(this._resolve) {
                this._resolve({ action: "cancel", data: null });
            }
        }

        public override show() : Promise<IPopupResult> {
            let instance = this;

            this.setContent(this._template);
            super.show();

            return new Promise<IPopupResult>((resolve) => {
                instance._resolve = resolve;
            });
        }
    }
}